class SearchAccountingTherapistHourId {

  constructor() {
    this.id = undefined;
    this.isHalfHour = undefined;
    this.therapistId = undefined;
    this.pricePerHour = undefined;
    this.patientId = undefined;
    this.appointmentId = undefined;
    this.sessionId = undefined;
    this.accountingEntryId = undefined;
    this.accountingSessionId = undefined;
    this.timeStamp = undefined;

    this.pagingParams = {
      pageNumber: undefined,
      pageSize: undefined
    }

  }
}

export default SearchAccountingTherapistHourId;